import styled from '@emotion/styled'
import type { FC } from 'react'

import LogoTiles from '@segment/templates/LogoTiles'
import FooterCompact from '@segment/templates/FooterCompact'

const Footer: FC = () => {
  return (
    <Wrapper>
      <LogoTiles />
      <FooterCompact />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

export default Footer
